import request from '@/utils/request'

export default {
  getHomeworkList(page, size, keyword, classId) {
    return request.get('/homework/list', {
      params: { page, size, keyword, classId }
    })
  },

  getHomeworkById(id) {
    return request.get(`/homework/${id}`)
  },

  addHomework(homeworkData) {
    return request.post('/homework/add', homeworkData)
  },

  updateHomework(homeworkData) {
    return request.put('/homework/update', homeworkData)
  },

  deleteHomework(id) {
    return request.delete(`/homework/${id}`)
  },

  uploadAttachment(file) {
    const formData = new FormData()
    formData.append('file', file)
    return request.post('/homework/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  getAnswerList(page, size, homeworkId, studentId) {
    return request.get('/homework/answer/list', {
      params: { page, size, homeworkId, studentId }
    })
  },

  scoreAnswer(answerData) {
    return request.put('/homework/answer/score', answerData)
  }
}
